import React from 'react';
import SVGImage from '../layout/SVGImage';
import { OperationSettlementButtonModalSubmitButton } from './OperationSettlementButtonModalSubmitButton';
import { useTranslation } from 'react-i18next';

interface OperationSettlementButtonModalProps {
  title?: string;
  description?: string;
  testId?: string;
  className?: string;
  onClick?: () => void;
}

export const OperationSettlementButtonModal: React.FC<
  OperationSettlementButtonModalProps
> = ({ title, description, testId, className, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-end ${className}`}
      data-testid={testId}
    >
      <SVGImage
        className="mb-[15px] cursor-pointer"
        testId={`${testId}-close-button`}
        name="cancle"
        onClick={onClick}
      />
      <div
        className={`w-full bg-white p-[30px] py-[25px] shadow-8 ${className}`}
      >
        <p
          className="noto-semibold-4 leading-[23px] text-dark-3"
          data-testid={`${testId}-title`}
        >
          {title}
        </p>
        <p
          className="noto-14-normal mt-[10px] leading-[23px] text-dark-8"
          data-testid={`${testId}-description`}
        >
          {description}
        </p>
        <div className="mt-[30px] flex items-center justify-end">
          <p
            onClick={onClick}
            className="noto-14-normal mr-[27px] cursor-pointer leading-[23px] text-dark-8"
            data-testid={`${testId}-cancle-button`}
          >
            {t('settlement.cancle')}
          </p>
          <OperationSettlementButtonModalSubmitButton
            testId={`${testId}-submit-button`}
          />
        </div>
      </div>
    </div>
  );
};
